<template>
  <div class="b-logo-small">
    <b-svg-icon name="saipient-logo-small" />
  </div>
</template>

<style lang="postcss">
.b-logo-small {
  .icons {
    @apply h-[24px] w-[90px];
  }
}
</style>
